module.exports = __webpack_public_path__ + "img/e49ec6a.png";